/** Normalizes API boolean-ish values for the post interaction flags. */
export const isEnabledFlagValue = (value) => {
  if (value === false || value === 0 || value === "0") return false;
  return true;
};

/** @deprecated kept for existing call sites — use isEnabledFlagValue. */
export const isCommentsEnabledValue = isEnabledFlagValue;

/** Whether the post allows comments (API: post_group.post.comments_enabled). */
export const arePostCommentsEnabled = (postGroup) =>
  isEnabledFlagValue(postGroup?.post?.comments_enabled);

/**
 * Whether the post allows reactions (API: post_group.post.reactions_enabled).
 * NB: `postGroup.reactions` is the per-type count map and a SIBLING of `post` —
 * the flag lives on the post itself.
 */
export const arePostReactionsEnabled = (postGroup) =>
  isEnabledFlagValue(postGroup?.post?.reactions_enabled);

/**
 * Whether the post hides its own date and time (API:
 * post_group.post.hide_post_datetime, "Nascondi data e ora del post").
 * Comment dates need no check here: for "Nascondi data e ora dei commenti" the
 * backend sends those comments without dates, which already render as none.
 */
export const isPostDatetimeHidden = (postGroup) =>
  postGroup?.post?.hide_post_datetime === true ||
  postGroup?.post?.hide_post_datetime === 1 ||
  postGroup?.post?.hide_post_datetime === "1";

/**
 * Whether the backend serving this payload knows about reactions_enabled.
 * Absent field => older backend: treat reactions as enabled (the helper above
 * already does) and hide the "Disattiva reazioni" menu item, so we never fire a
 * PUT the API would reject. Drop this once the backend change is everywhere.
 */
export const hasReactionsEnabledField = (postGroup) =>
  postGroup?.post?.reactions_enabled !== undefined;
